'use client';
import IconArrowLeft from '@/assets/icons/drawer-icons/icon-arrow-left.svg';
import {
  CollectionPublished,
  useCategoryListQuery,
  useCollectionListQuery,
} from '@/graphql';
import { mapEdgesToItems } from '@/helpers/maps';
import { useLanguageCode } from '@/hooks/useLanguageCode';
import { useTranslatedData } from '@/hooks/useTranslatedData';
import useCatalogStore from '@/zustand/useOpenCatalog';
import { useState } from 'react';
import styles from './main-page-cat.module.scss';
import { renderSkeletons } from '@/components/shared/skeleton';
import { renderCategory } from './renderCategory';
import { renderCollection } from './renderCollection';

const MainPageCategories = () => {
  const { setOpen } = useCatalogStore();
  const languageCode = useLanguageCode();

  const { data, loading } = useCategoryListQuery({
    variables: { first: 100, level: 0, languageCode: languageCode },
    context: { skipAuth: true },
  });

  const { data: collectionData, loading: collectionLoading } =
    useCollectionListQuery({
      variables: {
        first: 100,
        filter: { published: CollectionPublished.PUBLISHED },
      },
    });

  const mappedData = mapEdgesToItems(data?.categories);
  const translatedData = useTranslatedData(mappedData, ['name']);
  const parentCategories =
    translatedData
      ?.filter(
        edge =>
          edge.parent === null &&
          edge.isInCatalog === true &&
          edge.isBottom === false
      )
      .map(edge => edge) || [];

  const parentbottomCategories =
    data?.categories?.edges
      ?.filter(
        edge =>
          edge.node.parent === null &&
          edge.node.isInCatalog === true &&
          edge.node.isBottom === true
      )
      .map(edge => edge.node) || [];

  const [tab, setTab] = useState('');
  const totalCategories =
    parentCategories.length + parentbottomCategories.length;
  const handleTabChange = (index: string) => {
    setTab(index);
  };

  return (
    <div className={styles.mainPageCategory}>
      <div className={styles.mainPageCategoryWrapper}>
        {collectionLoading
          ? renderSkeletons(
              5,
              `${styles.mainPageCategoryItem} ${styles.skeleton}`
            )
          : renderCollection(
              collectionData?.collections?.edges,
              handleTabChange,
              tab,
              false,
              10
            )}
        {loading
          ? renderSkeletons(
              5,
              `${styles.mainPageCategoryItem} ${styles.skeleton}`
            )
          : renderCategory(parentCategories, handleTabChange, tab, 10)}
      </div>
      <div
        className={`${styles.mainPageCategoryWrapper} ${styles.bottomCategories}`}
      >
        {collectionLoading
          ? renderSkeletons(
              5,
              `${styles.mainPageCategoryItem} ${styles.skeleton}`,
              {
                marginTop: '10px',
              }
            )
          : renderCollection(
              collectionData?.collections?.edges,
              handleTabChange,
              tab,
              true,
              5
            )}
        {loading
          ? renderSkeletons(
              5,
              `${styles.mainPageCategoryItem} ${styles.skeleton}`,
              {
                marginTop: '10px',
              }
            )
          : renderCategory(parentbottomCategories, handleTabChange, tab, 5)}
      </div>
      {totalCategories > 12 && (
        <button
          type="button"
          className={styles.iconMore}
          onClick={() => setOpen(true)}
        >
          <IconArrowLeft />
        </button>
      )}
    </div>
  );
};

export default MainPageCategories;
